import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const vaccinationsApi = {
  async list(params = {}) {
    const response = await apiClient.get("/vaccinations", { params });
    return { data: unwrapList(response.data), meta: unwrapMeta(response.data) };
  },

  async count(params = {}) {
    const response = await apiClient.get("/vaccinations/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  },

  async getPetIntelligence(petId) {
    const response = await apiClient.get(`/vaccinations/pet/${petId}/intelligence`);
    return unwrapEnvelope(response.data, null);
  },

  async create(payload) {
    const response = await apiClient.post("/vaccinations", payload);
    return unwrapEnvelope(response.data, null);
  },

  async schedule(payload) {
    const response = await apiClient.post("/vaccinations/schedule", payload);
    return unwrapEnvelope(response.data, null);
  },

  async record(payload) {
    const response = await apiClient.post("/vaccinations/record", payload);
    return unwrapEnvelope(response.data, null);
  },

  async administer(id, payload) {
    const response = await apiClient.patch(`/vaccinations/${id}/administer`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async update(id, payload) {
    const response = await apiClient.put(`/vaccinations/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  }
};
